'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { DorahartLockup } from '@/components/brand/DorahartLogo'
import type { CMSMenuItem } from '@/lib/api/cms'

export function PublicNav({ items, locale }: { items: CMSMenuItem[]; locale: string }) {
  const pathname = usePathname()

  return (
    <header className='border-b border-[#1a1a1a]/10 bg-[#fffdfa]/90 backdrop-blur'>
      <nav className='mx-auto flex h-20 max-w-6xl items-center justify-between px-6'>
        <Link href={`/${locale}`} className='text-[#1a1a1a]'>
          <DorahartLockup monogramClassName='h-6 text-[#c9a96e]' wordmarkClassName='text-[1.05rem]' />
        </Link>

        <ul className='hidden items-center gap-9 md:flex'>
          {items.map((item) => {
            const href = `/${locale}/${item.meta.slug}`
            const isActive = pathname === href
            return (
              <li key={item.id}>
                <Link
                  href={href}
                  className={`text-xs tracking-[0.18em] uppercase transition-colors hover:text-[#c9a96e] ${
                    isActive ? 'text-[#1a1a1a]' : 'text-[#1a1a1a]/55'
                  }`}
                >
                  {item.title}
                </Link>
              </li>
            )
          })}
        </ul>

        <Link
          href={`/${locale}/auth/sign-in`}
          className='border border-[#1a1a1a]/20 px-5 py-2.5 text-[0.7rem] tracking-[0.2em] text-[#1a1a1a] uppercase transition-colors hover:border-[#c9a96e] hover:bg-[#1a1a1a] hover:text-[#fffdfa]'
        >
          Intranet
        </Link>
      </nav>
    </header>
  )
}
